import { styled, component } from '../../utils/style';
import { Button } from '../../components/Button/styles';
import { Input } from '../../components/Form/styles';
import { Format, StyleColor } from '../../utils/styles-constants';

export const StyledAuthentication = styled()(component.div, 'StyledAuthentication') `
`;

export const ExcelAuthenticationContainer = styled()(component.div, 'ExcelAuthenticationContainer')`
`;

export enum SamlIframeOrigin {
	App = 'app',
	Authentication = 'authentication'
}

interface SamlAuthenticationIframeProps {
	origin: SamlIframeOrigin;
}

export const SamlAuthenticationIframe = styled<SamlAuthenticationIframeProps>()(component.iframe, 'AuthenticationIframe')`
	position: absolute;
	border: none;
	top: 0;
	left: 0;
	${props => {
		switch (props.origin) {
			case SamlIframeOrigin.App:
				return (
					`width: 10%;
					height: 10%;
					display: none;`
				);
			case SamlIframeOrigin.Authentication:
				return (
					`width: 100%;
					height: 100%;
					vertical-align: top;
					bottom: 0;
					right: 0;`
				);
		}
	}}
`;

export const AuthenticationHeader = styled()(component.div, 'AuthenticationHeader') `
	background-color: ${StyleColor.White};
	position: absolute;
	right: 0;
	left: 0;
	z-index: 5;
	display: flex;
	box-sizing: border-box;
	padding: 0 15px;
	width: 100%;
	height: 44px;
	border: 0;
	border-bottom: 1px solid ${StyleColor.Grey200};
	justify-content: center;
	align-items: center;

	> * {
		flex-grow: 1;
		flex-basis: 33%;
	}

	@media ${Format.Smartphone}, ${Format.Tablet} {
		padding: 0 5px;
	}
`;

export const AuthenticationContent = styled()(component.div, 'AuthenticationContent') `
	flex-grow: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
`;

const blockButtonsStyle = `
	width: 100%;
	max-width: 430px;
	padding: 5px;
	box-sizing: border-box;
`;

const buttonCommonStyle = `
	max-width: none;
	width: 100%;
	outline: none;
`;

export const AuthenticationForm = styled()(component.form, 'AuthenticationForm') `
	${blockButtonsStyle}
`;

export const AuthenticateButton = Button.extend`
	border-color: ${StyleColor.Blue};
	background-color: ${StyleColor.Blue};
	color: ${StyleColor.White};
	max-height: 50px;
	margin: 0 auto;
	${buttonCommonStyle}

	@media (hover: hover) {
		&:hover {
			border-color: ${StyleColor.Blue};
			background-color: ${StyleColor.Blue};
			color: ${StyleColor.White};
		}
	}
`;

export const AuthenticateFormInputLogin = Input.extend`
	margin-bottom: 30px;
`;

export const AuthenticateFormInputPassword = Input.extend`
	margin-bottom: 30px;
`;

export const AuthenticateFormInputPhone = Input.extend`
	margin-bottom: 30px;
`;

export const AuthenticateFormInputCompany = Input.extend`
	margin-bottom: 30px;
`;

export const AuthenticationMethods = styled()(component.div, 'AuthenticationMethods') `
	${blockButtonsStyle}
`;

export const AuthenticationMethodButton = Button.extend`
	border-color: ${StyleColor.Grey300};
	background-color: ${StyleColor.White};
	color: ${StyleColor.Black};
	margin-bottom: 20px;
	border-radius: 3px;
	${buttonCommonStyle}
`;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Authentication/styles.ts